import { checkHttpStatus, checkToken } from '../utils/check-response'
import {default as types} from '../constants'
import {default as DataService} from '../services/data'
import {default as redirect} from '../utils/redirect'
import {default as Config} from '../config'
import { logoutAndRedirect } from '../actions/auth'

export function fetchZones(query) {
    return (dispatch, state) => {
        dispatch(fetchZonesRequest());

        //dispatch(logoutAndRedirect());

        return DataService.request(Config.apiUrl+'zone/index?pageSize=' + query.pageSize + '&page='+query.page+'&skip=' + query.skip, 
          { method: 'GET' }, 
          {}, 
          dispatch
        );
    }
}

export function fetchZonesRequest() {
  return {
    type: types.FETCH_ZONES_REQUEST,
    payload: {
    }
  }
}

export function formCreate() { 
  return {
    type: types.CREATE_ZONE_FORM,
    payload: {
    }
  }
}

export function formEdit() { 
  return {
    type: types.EDIT_ZONE_FORM,
    payload: {
    }
  }
}

export function fetchZone() {
    return (dispatch, state) => {
        dispatch(fetchZoneRequest());

        let states = state();

        return DataService.request(
          Config.apiUrl+'zone/get/'+states.routing.locationBeforeTransitions.query.id, 
          { method: 'GET'}, 
          {}, 
          dispatch
        ).then((response) => {
              dispatch(reciveZone(response.model, response.records));
              dispatch(formEdit());
        });
    }
}

export function fetchZoneRequest() {
  return {
    type: types.FETCH_ZONE_REQUEST,
    payload: {
    }
  }
}

export function reciveZone(model, records) {
  return {
    type: types.RECEIVE_ZONE,
    payload: {
      model: model,
      recors: records
    }
  }
}

export function fetchUsersRequest() {
  return {
    type: types.FETCH_USERS_REQUEST,
    payload: {
    }
  }
}

export function fetchUsers(input) {
    return (dispatch, state) => {
        dispatch(fetchUsersRequest());

        return DataService.request(Config.apiUrl+'user/users', { method: 'GET'}, {}, dispatch)
        .then((response) => {
          return { options: response };
        });
    }
}

export function reciveUsers(users) {
  return {
    type: types.RECEIVE_USERS,
    payload: {
      users: users
    }
  }
}

export function sendDataZone() {
  return {
    type: types.ZONE_FORM_SAVE,
    payload: {

    }
  }
}

export function saveArticleSuccess() {
  return {
    type: types.ARTICLE_FORM_SAVE_SUCCESS,
    payload: {

    }
  }
}

export function saveArticle(form) {
    return function(dispatch) {
        dispatch(sendDataZone());

        return DataService.request(Config.apiUrl+'zone/create', { method: 'POST'}, form.model, dispatch)
            .then(form.props.onSuccess)
            //.then(form.afterSend)
            .then(form.setErrorsOnInputs)
            .then(function(response){
                dispatch(saveArticleSuccess());
                redirect(dispatch, 'zones');
            });
    }
}


/** WEBPACK FOOTER **
 ** ./js/actions/zone.js
 **/